<template>
  <div>
    <!-- editor -->
    <editor :docCreate="docCreate" :initial="dataItem" @data="save"></editor>
    <!-- end -->
  </div>
</template>

<script>
import Editor from "../_components/editor.vue";
export default {
  components: {
    Editor,
  },
  data: () => ({
    dataItem: {},
    docCreate: true,
  }),
  methods: {

  },
};
</script>